import * as React from "react";
import cn from "classnames";

const styles = require("./style.less");

type DataTableFooterColumnProps = React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableDataCellElement>, HTMLTableDataCellElement>;

export class DataTableFooterColumn extends React.Component<DataTableFooterColumnProps> {
    render() {
        const { className, ...otherProps } = this.props;
        return (
            <td className={cn(className, styles.dataTableFooterColumn)} {...otherProps}>
                {this.props.children}
            </td>
        );
    }
}
